import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppSettingService } from '../../../../_services/_appSetting/app-setting.service';

@Component({
    selector: 'lokos-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrl: './date-picker.component.scss',
    standalone: false,
})
export class DatePickerComponent implements OnInit, OnChanges, OnDestroy {
    @Input({ required: false }) label = '';
    @Input({ required: true }) placeholder = 'placeholder';
    @Input({ required: false }) value = '';
    @Input({ required: true }) required = false;
    @Input({ required: false }) control: FormControl = new FormControl();
    @Input({ required: false }) readonly = false;
    @Input({ required: false }) maxDate: any = null;
    @Input({ required: false }) minDate: any = null;
    @Input() startView: 'month' | 'year' | 'multi-year' = 'month';
    @Input() panelClass?: string;
    @Input() matDatepickerFilter?: any;
    @Input() startAt: any = null;
    @Output() afterFocus = new EventEmitter();
    @Output() afterDateChange = new EventEmitter();
    @Output() monthSelected = new EventEmitter();
    @Output() yearSelected = new EventEmitter();

    theme = '';
    subscriptions: Subscription[] = [];
    lastSelectedMonth: any = null;

    constructor(
        private appSettingService: AppSettingService,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        const themeSub = this.appSettingService.appTheme$.subscribe(
            (theme) => (this.theme = theme)
        );
        this.subscriptions.push(themeSub);

        if (this.startView !== 'month') {
            if (!this.minDate) this.minDate = new Date(2023, 0, 1);
            if (!this.maxDate) this.maxDate = new Date();

            const statusSub = this.control.statusChanges.subscribe(() => {
                if (this.control.hasError('matDatepickerParse')) {
                    const { matDatepickerParse, ...rest } =
                        this.control.errors ?? {};
                    console.log('Date parsing error:', matDatepickerParse);
                    this.control.setErrors(
                        Object.keys(rest).length ? rest : null
                    );
                }
            });
            this.subscriptions.push(statusSub);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['value']) {
            this.control.patchValue(this.value);
        }
    }

    getErrorMessage() {
        const label = this.label
            ? this.translate.instant(this.label)
            : this.translate.instant('thisField');

        if (this.control.hasError('required')) {
            return `${label} ${this.translate.instant('isRequired')}`;
        }
        if (
            this.control.hasError('matDatepickerMax') ||
            this.control.hasError('max')
        ) {
            return this.translate.instant('noFutureDateAllowed');
        }
        if (
            this.control.hasError('matDatepickerMin') ||
            this.control.hasError('min')
        ) {
            return this.translate.instant('noPastDateAllowed');
        }
        if (this.control.hasError('matDatepickerParse')) {
            return `${this.translate.instant('invalidDateFormatFor')} ${label}`;
        }
        return '';
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub: Subscription) => {
            sub.unsubscribe();
        });
    }

    onMonthSelectEmit(
        normalizedMonthAndYear: any,
        datepicker: MatDatepicker<any>
    ) {
        this.lastSelectedMonth = normalizedMonthAndYear;
        this.monthSelected.emit(normalizedMonthAndYear);

        // Only close the picker if startView is 'year' (month picker mode)
        // For regular date picking (startView is 'month'), let the user select the day
        if (this.startView === 'year' || this.startView === 'multi-year') {
            datepicker.close();
        }
    }
    OnYearSelected(
        normalizedYear: moment.Moment,
        datepicker: MatDatepicker<any>
    ) {
        console.log('Year selected:', datepicker);
        this.yearSelected.emit(normalizedYear);
    }
}
